import React from "react";

import { Box } from "@chakra-ui/react";

export default function Tag(props) {
    return (
        <Box bg="white" color="black" px={3} py={2} mr={2} mb={{ base: 2, lg: 0 }} fontSize="sm" borderRadius="md">{props.name}</Box>
    )
}